
export function maxLenghtString (str, maxLength) {
    return str.length > maxLength ? `${str.substr(0, 10)}...${str.slice(-6)}` : str;
};